import { el, btn } from '@/ui/dom';
import { KIT_NUMBERS, TIFO_STYLES } from '@/config/cosmetics';

/**
 * modPickers.ts (M128/M128c) — the two mods that carry a CHOICE: the Kit
 * Number (1-11) and the Fan Tifo's design (smiley / SEE YA! / TOO SLOW!).
 * The chip rows are shared by the shop's detail dock (previews while
 * browsing, lands with the purchase) and the garage CUSTOMIZE dock (changes
 * the owned mod on the spot). `btn()` already clicks + buzzes per tap.
 */

export function renderNumberChips(host: HTMLElement, current: number, onPick: (n: number) => void): void {
  host.replaceChildren();
  host.style.display = '';
  el('span', 'shop-numpick-label', host).textContent = 'YOUR NUMBER';
  for (const n of KIT_NUMBERS) {
    btn(String(n), `shop-numpick-chip${n === current ? ' on' : ''}`, host, () => onPick(n));
  }
}

export function renderStyleChips(host: HTMLElement, current: number, onPick: (n: number) => void): void {
  host.replaceChildren();
  host.style.display = '';
  el('span', 'shop-numpick-label', host).textContent = 'CAPE DESIGN';
  for (const t of TIFO_STYLES) {
    const b = btn('', `shop-numpick-chip shop-stylechip${t.style === current ? ' on' : ''}`, host, () => onPick(t.style));
    el('span', 'shop-stylechip-label', b).textContent = t.label;
    el('span', 'shop-stylechip-blurb', b).textContent = t.blurb;
  }
}
